import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";

import { completeOnboarding } from "modules/user/api/onboarding";

import { AUTH_USER_QUERY_KEY } from "../queries/useAuthUserQuery";

import { UserRole } from "modules/user/types/entities";

export const useCompleteOnboardingMutation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<void, AxiosError, { user_role: UserRole }>({
    mutationFn: completeOnboarding,
    onSettled: async () => {
      await queryClient.invalidateQueries(AUTH_USER_QUERY_KEY);
    }
  });

  return mutation;
};
